import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
import CavinImg from '../images/cavinimg.jpg';

const projects = [
  {
    id: 1,
    name: 'Tour & Trip',
    overview:
      'The website is an e-commerce based website where a travel agency publishes its available tour packages, provide hotel renting facilities and transport information and many more',
    desc: [
      'Booking tour packages, hotels etc\n',
      'Show the route maps of different types of transportation service like bus, cruise and plane.\n',
      'One must login with the website to place any order. They can place order by providing personal valid information\n',
      'There is also a facility to cancel the order until the order is confirmed by the admin.\n',
      'Admin can approve or cancel an order. He may also add new packages, hotels and transports.\n',
    ],
    req: [
      'HTML5,\n',
      'CSS3,\n',
      'React, \n',
      'Node, \n',
      'Express, \n',
      'MongoDB, \n',
      'Firebase \n',
    ],
    clientLink: 'https://github.com/MohosinPalash/Tour-and-Trip',
    serverLink: 'https://github.com/MohosinPalash/Tour-and-Trip-Server',
    liveLink: 'https://tour-and-trip.web.app/',
    img1: 'https://i.ibb.co/V20mwQh/tt1.png',
    img2: 'https://i.ibb.co/5Yt50YF/tt2.png',
    img3: 'https://i.ibb.co/4fNt4TN/tt3.png',
    img4: 'https://i.ibb.co/Sxsh1Wt/tt4.png',
  },
  {
    id: 2,
    name: 'MEDICA',
    overview:
      'This a Health Care Related Project. MEDICA is a renowned hospital in the city. And provide services with a good quality and cheaper rate.',
    desc: [
      'Home: It contains a banner, services list, doctors list and news and events',
      'Doctor: All the doctors information are available here and there is another healthy foods section here',
      'News: This section contains some blogs about recent facts about',
      'Login: Login using Firebase Authentication is implemented.',
      'The website is responsive',
    ],
    req: [
      'HTML5, \n',
      'CSS3, \n',
      'React Bootstrap, \n',
      'React Route, \n',
      'Express, \n',
      'Firebase \n',
    ],
    clientLink: 'https://github.com/MohosinPalash/Medica',
    serverLink: '',
    liveLink: 'https://medica-48810.web.app/home',
    img1: 'https://i.ibb.co/yBPFJxJ/md1.png',
    img2: 'https://i.ibb.co/fF6KbQd/md2.png',
    img3: 'https://i.ibb.co/WDNPmM3/md3.png',
    img4: 'https://i.ibb.co/9NQcw0s/md4.png',
  },
  {
    id: 3,
    name: 'Bike Gallery',
    overview:
      'This is a bike shop website. This contains the dealership of ROYAL ENFIELD. The project is a demo project developed to practice Node and MongoDB',
    desc: [
      'Collections of lots of bikes and accessories ',
      'Clients can review and rate the service ',
      'Admin can manage order, Manage Product, Add Product and create new admin ',
      'users features are order summary, payment gateway and review the service ',
      'Someone may create his own profile along with GOOGLE authentication or by creation account with email address. ',
    ],
    req: [
      'Material UI, \n',
      'HTML5, \n',
      'CSS3, \n',
      'React, \n',
      'Node, \n',
      'Express, \n',
      'MongoDB, \n',
      'Firebase \n',
    ],
    clientLink: 'https://github.com/MohosinPalash/Bike-Gallery',
    serverLink: 'https://github.com/MohosinPalash/Bike-Gallery-Server',
    liveLink: 'https://bike-gallery-fc89a.web.app/',
    img1: 'https://i.ibb.co/YTdnHXq/bg1.png',
    img2: 'https://i.ibb.co/4SydP3p/bg2.png',
    img3: 'https://i.ibb.co/TczMkjF/bg3.png',
    img4: 'https://i.ibb.co/zGpJh3f/bg4.png',
  },
  {
    id: 4,
    name: 'eWallet',
    overview:
      'eWallet, a virtual wallet that is used to pay bill.  you can pay the utility bill, vehicles toll, recharge mobile balance and so on by using a single software.',
    desc: [
      'Three types of users may use this software. They are admin, agent and general users.',
      'General users can deposit and withdraw money. They can also transfer and pay to their respective shops and clients.',
      'Admin controls the users, agents and other admins.',
      'Agents are the source of withdraw and deposit money of the users',
      'Every types of users has to deal with a proper authentication system.',
    ],
    req: ['Java, \n', 'Java swing, \n', 'MSSQL \n'],
    clientLink: 'https://github.com/MohosinPalash/eWallet',
    serverLink: '',
    liveLink:
      'https://www.facebook.com/mohosinislam.palash/videos/2043032695839496',
    img1: 'https://i.ibb.co/gPDStPs/ew1.png',
    img2: 'https://i.ibb.co/FVmFjbc/ew2.png',
    img3: 'https://i.ibb.co/K2bxZhH/ew3.png',
    img4: 'https://i.ibb.co/bzWxVzG/ew4.png',
  },
  {
    id: 5,
    name: 'Course4All',
    overview:
      'This a Health Care Related Project. MEDICA is a renowned hospital in the city. And provide services with a good quality and cheaper rate.',
    desc: [
      'The homepage contains some of the four or five courses information.',
      'In services page all the courses are show here.',
      'In instructor section, popular courses and instructors are available.',
      'The about page contains the goal of the educational website',
      'The website is responsive.',
    ],
    req: [
      'HTML5, \n',
      'CSS3, \n',
      'React Bootstrap, \n',
      'React Route, \n',
      'API\n',
    ],
    clientLink: 'https://github.com/MohosinPalash/Course4All',
    serverLink: '',
    liveLink: 'https://course4all.netlify.app/home',
    img1: 'https://i.ibb.co/LtRM2gN/cf1.png',
    img2: 'https://i.ibb.co/RgsFgTv/cf2.png',
    img3: 'https://i.ibb.co/mR4vzGs/cf3.png',
    img4: 'https://i.ibb.co/QXWBzBv/cf4.png',
  },
];

export default projects;
